export const APPLICATION_SET_HEADER = "APPLICATION_SET_HEADER";
export const APPLICATION_SET_CURRENT_NAV = "APPLICATION_SET_CURRENT_NAV";
export const APPLICATION_SET_LOADER = "APPLICATION_SET_LOADER";

export function setHeader(str) {
    return {
        type: APPLICATION_SET_HEADER,
        payload: {
            label: str,
        },
    };
}

export function setCurrentNav(str) {
    return {
        type: APPLICATION_SET_CURRENT_NAV,
        payload: {
            item: str,
        },
    };
}

export function setLoaderState(payload) {
    return {
        type: APPLICATION_SET_LOADER,
        payload: {
            loaderOpen: payload,
        },
    };
}
